module.exports = __webpack_public_path__ + "static/img/bim3331.721e7665.png";